import styled from "styled-components";

import { theme } from "@/components/bild/theme";
import { colors } from "@/styles/Variants";

const color = colors.bild;
const { fontFamily, breakpoint } = theme;

export const Headline = styled.div`
  display: flex;
  margin-bottom: 24px;
  font-family: ${fontFamily.gothamXNarrow};
  font-size: 18px;
  font-weight: 700;
  color: ${color.vader500};
  line-height: 1.3;

  @media ${breakpoint.medium} {
    font-size: 16px;
  }
  @media ${breakpoint.small} {
    font-size: 16px;
  }
`;

export const Subheader = styled.div`
  display: flex;
  margin-top: 24px;
  font-weight: 800;
  font-family: ${fontFamily.gotham};
  font-size: 20px;
  color: ${color.vader500};
  line-height: 1;

  @media ${breakpoint.medium} {
    font-size: 18px;
  }
  @media ${breakpoint.small} {
    font-size: 16px;
  }
`;

export const RadioGroupWrapper = styled.div`
  display: flex;
  /* ESD-2418 §3.7: wrap the four salutation options so they never overflow at 360px. */
  flex-wrap: wrap;
  row-gap: 12px;
  margin: 16px 0px;

  /* Each child is the clickable RadioWrapper (a <label>) — give it a real ≥44px tap target with
     the indicator + text vertically centred. */
  & > * {
    margin-right: 24px;
    min-height: 44px;
    align-items: center;
  }
`;

export const TextFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;

  & > * {
    margin-bottom: 24px;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`;
